import angular from 'angular';

export default angular.module('petroCloud.ngTouchEvents', [])
  .directive('ngTouchstart', () => ({
    controller: NGTouchStartController
  }))
  .directive('ngTouchmove', () => ({
    controller: NGTouchMoveController
  }))
  .directive('ngTouchend', () => ({
    controller: NGTouchEndController
  }))
  .name;

/* @ngInject */
function NGTouchStartController($scope, $element) {
  $element.bind('touchstart', onTouchStart);

  function onTouchStart(event) {
    event.preventDefault();
    const method = $element.attr('ng-touchstart');
    $scope.$event = event;
    $scope.$apply(method);
  }
}

/* @ngInject */
function NGTouchMoveController($scope, $element) {
  $element.bind('touchmove', onTouchMove);

  function onTouchMove(event) {
    event.preventDefault();
    const method = $element.attr('ng-touchmove');
    $scope.$event = event;
    $scope.$apply(method);
  }
}

/* @ngInject */
function NGTouchEndController($scope, $element) {
  $element.bind('touchend', onTouchEnd);

  function onTouchEnd(event) {
    event.preventDefault();
    const method = $element.attr('ng-touchend');
    $scope.$event = event;
    $scope.$apply(method);
  }
}
